import React from 'react'
import { Icon } from '@cps'
import { format } from '@dt/fe-utils'
import { useHistoryNew } from '@utils'
import './index.scss'

interface IProps {
  orderId: string;
  details: any[];
  onClose: () => void;
}

const splitName = (value: any) => String(value || '').split('--').filter(Boolean)

const ActivityReserveTicket: React.FC<IProps> = ({ orderId, details, onClose }) => {
  const history = useHistoryNew()
  const detail = details?.[0] || {}
  const [activityName = i18n.t('mkt.activityReserve.title'), storeName = ''] = splitName(detail.productName)
  const [scheduleName = '', ticketName = ''] = splitName(detail.productScaleName)
  const ticketDetail = [scheduleName, ticketName].filter(Boolean).join(' · ')

  const handleUse = () => {
    onClose()
    history.replace(`/activityReserve/record/${orderId}`)
  }

  return (
    <div className='activity-ticket-modal'>
      <div className='activity-ticket-dialog'>
        <button className='activity-ticket-close' aria-label={i18n.t('mkt.activityReserve.close')} onClick={onClose}>
          <Icon name='close' />
        </button>
        <div className='activity-ticket-heading'>{i18n.t('mkt.activityReserve.reservationSuccess')}</div>
        <div className='activity-ticket-tip'>{i18n.t('mkt.activityReserve.ticketAdded')}</div>
        <div className='activity-ticket-card'>
          <div className='activity-ticket-main'>
            <strong>{activityName}</strong>
            {storeName && <span>{storeName}</span>}
          </div>
          {ticketDetail && <div className='activity-ticket-detail'>{ticketDetail}</div>}
          <div className='activity-ticket-meta'>
            <em>{format.toPrice(detail.paidFee ?? detail.originalFee ?? 0)}</em>
            <span>{i18n.t('mkt.activityReserve.quantityMultiplier', { count: detail.cnt || 1 })}</span>
          </div>
        </div>
        <button className='activity-ticket-use' onClick={handleUse}>{i18n.t('mkt.activityReserve.useNow')}</button>
      </div>
    </div>
  )
}

export default ActivityReserveTicket
